/*
 * @Author: 赵修瞾
 * @Date: 2020-04-05 09:46:17
 * @LastEditors: 赵修瞾
 * @LastEditTime: 2020-05-15 17:28:00
 * @FilePath: \www\src\api\home.js
 * @Description:
 */
import {
    ajax
} from '@/utils/request'

// 顶部banner列表
export function topBanner() {
    return ajax('api/v1/bd/h5/home/banner')
}

// 中间banner列表
export function middleBanner() {
    return ajax('api/v1/bd/h5/home/carouse')
}

// 弹窗广告
export function windowInfo() {
    return ajax('api/v1/bd/h5/home/popUp')
}

// 代驾服务
export function drivingservices(params) {
    return ajax('api/v1/shop/driveService/h5/home/list', params)

}
// 车主用品
export function caraccessories(params) {
    return ajax('api/v1/goods/homePageRecommended', params)
}

// 获取首页广告状态
export function bannerStatus() {
    return ajax('api/v1/bd')
}

// 获取魔方数据
export function rubiksCube() {
    return ajax('api/v1/bd/cubeRecommend')
}

// 获取推荐分类
export function recommendType() {
    return ajax('api/v1/goodsCategory/recommendedCategory')
}